import FullScreenModal from "./FullScreenModal"
import ShareModal from "./ShareModal"
import DeleteModal from "./DeleteModal"
import LogoutModal from "./LogoutModal"
import DownloadModal from "./DownloadModal"
import MoveFolderModal from "./MoveFolderModal"
import ExpiredSubscription from "./ExipiredSubscription"
import SwitchRoleModal from "./SwitchRoleModal"
import UploadModal from "./UploadModal"
import AddToAlbumModal from "./AddToAlbumModal"

const Modals = () => {
  return (
    <>
      <ExpiredSubscription />
      <FullScreenModal />
      <ShareModal />
      <DownloadModal />
      <DeleteModal />
      <MoveFolderModal />
      <LogoutModal />
      <SwitchRoleModal />
      <UploadModal />
      <AddToAlbumModal />
    </>
  )
}

export default Modals
